import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { Modal } from "../../Modal";
import icons from "../../../constants/icons";
import { fetchWalletBalance } from "../../../queries/wallet/walletQuery";
import { getStorage } from "../../../utils/storage";
import { fetchRequestBalance } from "../../../queries/wallet/requestQuery";
import ViewBalance from "../balance/ViewBalance";
import moment from "moment";
import SingleTransactionView from "../../Transactions/SingleTransactionView";

class WalletRequest extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
    page: 0,
    limit: 10,
    filters: {
      startDate: moment()
        .subtract(30, "days")
        .startOf("D")
        .format("YYYY-MM-DD"),
      endDate: moment().endOf("D").format("YYYY-MM-DD"),
    },
  };

  componentDidMount() {
    this.getData(true, this.state.filters);
  }

  getData = async (isLoading, search = {}) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading, ...search });

      const { merchantID } = await getStorage("merchantID");

      const { content, totalPages } = await fetchRequestBalance(
        defaultLanguage,
        {
          merchantId: merchantID,
          ...search,
        }
      );

      this.setState({
        isLoading: false,
        data: content,
        totalPageCount: totalPages,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].date,
        key: "dateCreated",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].processor_transaction_id,
        key: "processorTransactionId",
      },
      {
        title: language[this.props.defaultLanguage].request_narration,
        key: "requestNarration",
      },
      {
        title: language[this.props.defaultLanguage].service_account,
        key: "serviceAccount.name",
      },
      {
        title: language[this.props.defaultLanguage].phone_number,
        key: "phoneNumber",
      },
      {
        title: language[this.props.defaultLanguage].amount,
        key: "amount",
      },
      {
        title: language[this.props.defaultLanguage].transaction_transfer_type,
        key: "transactionTransferType",
      },

      {
        title: language[this.props.defaultLanguage].status,
        key: "transferResult",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "multiple-actions",
        actions: [
          {
            icon: icons.eye_on,
            title: language[this.props.defaultLanguage].view,
            onPress: (item) =>
              this.handleShowModal(
                "showModal",
                `Transaction ${item.processorTransactionId}`,
                item
              ),
          },
        ],
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          filters={[
            {
              title: language[this.props.defaultLanguage].date_range,
              button_type: "dropdown",
              icon: icons.calendar,
              filterName: "date",
              handleApply: (date) => this.getData(true, date),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          {/* <ViewBalance
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          /> */}
          <SingleTransactionView
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            transaction={this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(WalletRequest);
